<template>
  <div class="container">
    <div class="section-container">
      <div class="navigation">
        <Link :href="$route('company.login')">
          <Button class="btn--tonal"> ¿Ya tienes cuenta? </Button></Link
        >
      </div>
      <div class="form-container">
        <header>
          <h1 class="headline-large">Crea tu cuenta ahora, ¡gratis!</h1>
          <p class="title-large">
            Lorem ipsum dolor sit, amet consectetur adipisicing elit.
          </p>
          <form @submit.prevent="submit">
            <text-input
              id="fullname"
              v-model="form.fullname"
              label="Nombre"
              icon="person-outline"
              :required="true"
              :error="errors.fullname"
            ></text-input>
            <text-input
              id="email"
              v-model="form.email"
              type="email"
              label="Correo empresarial"
              icon="mail-outline"
              :required="true"
              :error="errors.email"
            ></text-input>
            <text-input
              id="password"
              v-model="form.password"
              type="password"
              label="Contraseña"
              icon="lock-outline"
              hint="Elige una contraseña segura entre 8 y 16 carácteres"
              :required="true"
              :error="errors.password"
            ></text-input>
            <text-input
              id="password_confirmation"
              v-model="form.password_confirmation"
              type="password"
              label="Confirmar contraseña"
              icon="lock-check-outline"
              hint="Asegúrate que las contraseñas coincidan"
              :required="true"
              :error="errors.password_confirmation"
            />
            <check-input
              id="terms_and_conditions_agreement"
              v-model="form.terms_and_conditions_agreement"
              label="He leído y acepto los Términos y Condiciones del Sitio"
              :class="'checkbox-left'"
              :required="true"
              :error="errors.terms_and_conditions_agreement"
            />
            <Button type="submit" class="d-block my-3 mx-auto btn--filled">
              Crear mi cuenta
            </Button>
          </form>
        </header>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/Layouts/Layout'
import { Link } from '@inertiajs/inertia-vue'
import Icon from '@/Components/Icon'
import TextInput from '@/Components/Form/TextInput'
import SelectInput from '@/Components/Form/SelectInput'
import Button from '@/Components/Button'
import CheckInput from '@/Components/Form/CheckInput'

export default {
  name: 'RegistroEmpresas',
  layout: Layout,
  components: { Link, Icon, TextInput, SelectInput, CheckInput, Button },
  props: {
    errors: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        fullname: '',
        email: '',
        password: '',
        password_confirmation: '',
        terms_and_conditions_agreement: false,
      }),
    }
  },
  methods: {
    submit() {
      this.form.post(this.$route('company.register.store'))
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../scss/utilities/theme';
@import '../../../scss/utilities/mixins';

.container {
  display: flex;
  justify-content: center;

  .section-container {
    padding-top: 56px;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .form-container {
      @include lg {
        margin: 0px 48px;
      }
    }

    .navigation {
      display: flex;
      justify-content: right;
    }

    // Apply styles on large screens
    @include lg {
      width: 552px;
    }
  }
}
</style>
